import { Box } from 'theme-ui'
import Head from 'next/head'

import Default from 'src/layouts/Default'
import Header from 'src/components/navigation/header/Header'
import Background from 'src/components/background/Background'
import Type from 'src/components/gel/Type'

import type { WithChildren } from 'src/types/utils'

const ErrorPage = ({ title, children }: WithChildren & { title: string }) => (
  <Default withNewsletter={false}>
    <Head>
      <title>{title} - BBC Studios Advertising</title>
      <link rel="icon" type="image/x-icon" href="/favicon.ico" />
    </Head>
    <Header />
    <Box as="main">
      <Background backgroundColor="background.primary">
        <Box sx={{ py: [13, null, 15], px: [4, null, 13, 15], textAlign: 'left' }}>
          <Type variant="SectionTitleSerif" as="h1" sx={{ pb: 8 }}>
            {title}
          </Type>
          {children}
        </Box>
      </Background>
    </Box>
  </Default>
)

export default ErrorPage
